/**
 * Social media link with platform type and URL.
 */
export type SocialMediaLink = {
  type: SocialMediaType;
  link: string;
};

/**
 * Supported social media platform types.
 */
export type SocialMediaType =
  | 'instagram'
  | 'youtube'
  | 'soundcloud'
  | 'twitter'
  | 'x'
  | 'facebook'
  | 'appleMusic'
  | 'spotify';

/**
 * Type guard to check if a string is a valid SocialMediaType.
 * @param key - String to validate
 * @returns True if key is a valid SocialMediaType
 */
export const isSocialMediaType = (key: string): key is SocialMediaType => {
  return [
    'instagram',
    'youtube',
    'soundcloud',
    'twitter',
    'x',
    'facebook',
    'appleMusic',
    'spotify',
  ].includes(key);
};

/**
 * Options for configuring share link behavior.
 */
export type ShareLinkOptions = {
  excludeEmail?: boolean;
  excludeCopyToClipboard?: boolean;
};

/**
 * Input type for a single social media item.
 */
export type SocialMediaItemInput = {
  type: SocialMediaType;
  link: string;
};

/**
 * Input type for social media links as a partial record.
 * Allows specifying links for only some platforms.
 */
export type SocialMediaInput = Partial<Record<SocialMediaType, string>>;

/**
 * Array of social media links.
 */
export type SocialMedia = Array<SocialMediaLink>;
